/*
 * @Author: aalizzwell
 * @Date: 2019-05-31 09:48:10
 * @Last Modified by: aalizzwell
 * @Last Modified time: 2019-06-24 17:00:58
 */

import { FrameContext } from '@farris/devkit';
import { TreeNode, TreeTableComponent } from '@farris/ui-treetable';
import { ParentHierarchyInfo } from './types';
// tslint:disable: no-string-literal max-line-length
/**
 * æ èç¹æé å¨
 * @summary
 * å°BindingDataä¸­çæ°æ®éåè½¬æ¢æTreeTableèç¹éå
 */
class ParentTreeNodeBuilder {
  private frameContext: FrameContext;
  /**
   * æé å½æ°
   */
  constructor(allNodesData: any[], oldTreeNodes: TreeNode[], primaryKey: string, hierarchyInfoKey: string, context?: any) {
    this.primaryKey = primaryKey;
    this.hierarchyInfoKey = hierarchyInfoKey;
    this.allNodes = [];
    this.allNodesData = allNodesData;
    this.context = context || {};
    this.nodesWaitExpand = [];
    this.nodesShouldExpand = context && context.nodesShouldExpand || [];
    this.frameContext = context && context.frameContext || null;
    this.addTreeLoadCompleteListener(this.onTreeLoadComplete.bind(this));

    this.allNodesMap = new Map<string, TreeNode>();
    this.allOldNodesMap = new Map<string, TreeNode>();
    this.buildNodesDataMap(oldTreeNodes);
  }
  /**
   * å±å¼è³å±çº§
   * @description -1ä¸ºä¸å±å¼
   */
  private get expandLevel() {
    return this.context && this.context.hasOwnProperty('expandLevel') ? this.context['expandLevel'] : -1;
  }
  private get component(): TreeTableComponent {
    return this.context && this.context['component'];
  }
  private get addTreeLoadCompleteListener() {
    return this.context && this.context['addTreeLoadCompleteListener'] || function (args: any) { };
  }
  /**
   * éè¦å±å¼çèç¹
   */
  private nodesShouldExpand: string[];

  /**
   * ç­å¾å±å¼çèç¹
   * @description èç¹ç»æ
   * ```
   * {id:'xxx',expanded:false}
   * ```
   */
  private nodesWaitExpand: any[] = [];

  /**
   * ä¸»é®å­æ®µå
   */
  private primaryKey: string;

  /**
   * åçº§ç å­æ®µå
   */
  private hierarchyInfoKey: string;

  /**
   * èç¹çæ°æ®éå
   */
  private allNodesData: any[];

  /**
   * èç¹éå
   */
  private allNodes: TreeNode[];

  /**
   * ä¸ä¸æ¬¡ç»å®çæ èç¹éåMap
   */
  private allNodesMap: Map<string, TreeNode>;

  /**
   * ä¸ä¸æ¬¡ç»å®çæ èç¹éåMap
   */
  private allOldNodesMap: Map<string, TreeNode>;

  /**
   * ä¸ä¸æ
   */
  private context: any;

  public updateTreeNode(allNodesData: any, data: any) {
    this.allNodesData = allNodesData;
    this.buildNodesDataMap(data);
  }
  public build(): TreeNode[] {
    let tree: TreeNode[] = [];
    const childrenOf = {};
    const parents = {};
    const nodes = {};
    this.allNodesData.forEach(item => {
      const id = item.id;
      const parentId = this.getHierarchyInfo(item).parentElement;

      // item.parentId = parentId;
      // å±å¼æ°å¢èç¹çç¶èç¹
      const isNewNode = this.isNewNode(item);
      if (isNewNode === true) {
        this.expandParentNode(item);
      }
      // æé æ èç¹
      const node = this.buildNode(item);
      nodes[id] = node;
      childrenOf[id] = childrenOf[id] || [];
      node.children = childrenOf[id];

      parents[parentId] = parents[parentId] || [];
      parents[parentId].push(node);
      this.allNodesMap.set(item[this.primaryKey], node);
      if (parentId) {
        if (nodes[parentId] && nodes[parentId].unstableState === true) {
          nodes[parentId].expanded = true;
          nodes[parentId].unstableState = false;
        }
        childrenOf[parentId] = childrenOf[parentId] || [];
        childrenOf[parentId].push(node);
      } else {
        if ((!node.children || node.children.length < 1) && node.expanded === true) {
          node.unstableState = true;
          node.expanded = false;
        }
        tree.push(node);
      }
    });
    // ææèç¹é½æ¯parentIdï¼æ²¡æè¿åæ ¹èç¹
    if ((!tree || tree.length < 1) && this.allNodesData && this.allNodesData.length > 0) {
      const parentIds = Object.keys(parents);
      parentIds.forEach(parentId => {
        if (!this.allNodesData.find(item => item.id === parentId)) {
          tree = tree.concat(parents[parentId]);
        }
      });
    }
    return tree;
  }
  /**
   * æé æ èç¹
   */
  public build1(): TreeNode[] {
    let minLayer;
    // è·åæé¡¶çº§èç¹çlayer
    this.allNodesData.forEach(node => {
      const hierarchyInfo = this.getHierarchyInfo(node);
      if (hierarchyInfo) {
        const layer = hierarchyInfo['layer'];
        if (!isNaN(layer)) {
          if (minLayer === undefined) {
            minLayer = layer;
          } else if (layer < minLayer) {
            minLayer = layer;
          }
        }
      }
    });
    const topLayer = minLayer - 1;
    this.buildNodes('', topLayer, this.allNodesData, this.allNodes);
    return this.allNodes;
  }

  /**
   * æé æ èç¹éå
   */
  private buildNodes(fParentElement: string, fLayer: number, allNodesData: any[], treeNodes: TreeNode[]): void {
    const childNodesData = this.getChildNodesData(fParentElement, fLayer);
    childNodesData.forEach((nodeData: any) => {

      // å±å¼æ°å¢èç¹çç¶èç¹
      const isNewNode = this.isNewNode(nodeData);
      if (isNewNode === true) {
        this.expandParentNode(nodeData);
      }

      // æé æ èç¹
      const node = this.buildNode(nodeData);
      treeNodes.push(node);
      this.allNodesMap.set(nodeData[this.primaryKey], node);

      // éå½éåä¸çº§èç¹
      const hierarchyInfo = this.getHierarchyInfo(nodeData); //nodeData[this.hierarchyInfoKey];
      const currentLayer = hierarchyInfo['layer'];
      const currentId = nodeData[this.primaryKey];
      this.buildNodes(currentId, currentLayer, allNodesData, node.children as TreeNode[]);
    });
  }

  /**
   * åå»ºæ èç¹
   */
  private buildNode(nodeData: any): TreeNode & { unstableState?: boolean } {
    const isLeaf = this.isLeaf(nodeData);
    // è·åèç¹çå±å¼ç¶æ
    const shouldExpand = this.shouldExpand(nodeData);
    // èç¹è½ç¶åºè¯¥å±å¼ï¼ä½å¯è½æ¯å ä¸ºä¹åå°±æ¯å±å¼ç¶æï¼æä»¥åºè¯¥æ£æ¥èç¹ä¹åçç¶æ
    const originExpandStatus = this.isExpanded(nodeData);
    // å¦æåºè¯¥å±å¼è¯¥èç¹ï¼ä½æ¯è¯¥èç¹ä¹åæç¶æï¼é£ä¹è¯¥èç¹ä¸åºè¯¥åç±ç¨åºå±å¼ã
    if (!originExpandStatus && shouldExpand) {
      this.expandNode(nodeData);
    }
    const paginationInfo = this.buildPaginationInfo(nodeData);
    const treeNode: TreeNode = {
      data: Object.assign({}, nodeData),
      children: [],
      expanded: shouldExpand,
      leaf: isLeaf
    };
    if (paginationInfo) {
      treeNode.pagination = paginationInfo;
    }
    return treeNode;
  }
  /**
   * æé åé¡µä¿¡æ¯
   * @param nodeData nodeData
   * @returns
   */
  private buildPaginationInfo(nodeData: any): { pageIndex: number, pageSize: number, total: number } | null {
    let result = null;
    if (this.frameContext) {
      const id = this.getPrimary(nodeData);
      // è·ååé¡µä¿¡æ¯
      const key = `_NODE_${id}_PAGINATION_INFO_`;
      const pagination = this.frameContext.params.get(key) || null;
      if (pagination && pagination.pageCount > 1) {
        result = {
          pageIndex: pagination.pageIndex,
          pageSize: pagination.pageSize,
          total: pagination.totalCount
        };
      }
    }
    return result;
  }
  /**
   * è®¡ç®èç¹æ¯å¦è¦å±å¼
   * @param nodeData nodeData
   */
  private shouldExpand(nodeData: any) {
    const [isLeaf, layer] = [this.isLeaf(nodeData), this.getNodeLayer(nodeData)];
    // æ°¸è¿ä¸å±å¼å¶å­èç¹
    if (isLeaf) {
      return false;
    }
    let expanded = this.isExpanded(nodeData);
    if (expanded === undefined) {
      const id = this.getPrimary(nodeData);
      if (this.nodesWaitExpand.findIndex((node) => node && node.id === id) > -1) {
        return false;
      }
      if (this.nodesShouldExpand.findIndex((nodeId) => nodeId === id) > -1) {
        return true;
      }
      if (this.expandLevel === -1) {
        // -1 ä¸ºä¸å±å¼
        expanded = false;
      } else if (this.expandLevel === 0) {
        // 0 ä¸ºå¨é¨å±å¼
        expanded = true;
      } else {
        // æ²¡æå¯ç¨åå±å è½½ï¼éè¿å±å¼å±çº§ç¡®å®æ¯å¦å±å¼è¯¥èç¹
        expanded = layer <= this.expandLevel;
        // å¦æèç¹åæ¬å­å¨ä¸èç¹æ²¡æå±å¼åä¸å±å¼
        const oldTreeNode = this.getOldNode(nodeData);
        if (oldTreeNode && !oldTreeNode.expanded) {
          expanded = false;
        }
      }
    }
    return expanded;
  }
  /**
   * å±å¼æ èç¹
   * @description å®å¨å è½½æ ä½¿ç¨å±å¼å±æ§å¨buildNodeæ¶å·²ç»å±å¼ï¼æ­¤å½æ°çä¸»è¦ç¨äºå±å¼åçº§å è½½æ 
   * @param nodeData nodeData
   */
  private expandNode(nodeData: any) {
    const [element, layer] = [nodeData[this.primaryKey], this.getNodeLayer(nodeData)];
    const childs = this.getChildNodesData(element, layer);

    // å½åèç¹ä¸æ¯å¶å­èç¹ï¼ä½å¨èç¹æ°æ®ä¸­åæ¾ä¸å°è¯¥èç¹çå­èç¹ï¼åè®¤ä¸ºæ å¯ç¨äºåå±å è½½
    if (!childs || childs.length < 1) {
      // åå±å è½½æ éè¦éè¿è§¦åèç¹å±å¼äºä»¶æå è½½ä¸å±,ç®åæ ä¸è¿ä¸å­å¨è¯¥èç¹ï¼æ æ³ç´æ¥å±å¼ï¼éè¦ç­æ å è½½å®ä¹ååå±å¼
      const id = this.getPrimary(nodeData);
      if (this.nodesWaitExpand.findIndex(node => node && node.id === id) < 0) {
        this.nodesWaitExpand.push({ id, expanded: false });
      }
    }
  }
  /**
   * æ å è½½å®æäºä»¶
   */
  private onTreeLoadComplete() {
    const index = this.nodesWaitExpand.findIndex(node => !node.expanded);
    const nodeData = this.nodesWaitExpand[index] || {};
    const { id } = nodeData;
    if (id) {
      const rowNode = this.component.findRowNode(id);
      if (rowNode) {
        nodeData.expanded = true;
        // if (nodeData && nodeData.node && !nodeData.node.expanded) {
        //   return;
        // }
        this.component.expandNode(id);
      }
    }
  }
  /**
   * è·åä¸»é®
   * @param nodeData nodeData
   */
  private getPrimary(nodeData: any) {
    return nodeData[this.primaryKey];
  }
  // #region å·¥å·æ¹æ³ï¼å¾åç¬å°è£

  /**
   * è·åå­çº§èç¹çæ°æ®éå
   */
  private getChildNodesData(fParentElement: string, fLayer: number): any[] {
    const childNodesData = [];
    this.allNodesData.forEach((nodeData: any) => {

      // @todoï¼å¾å é¤ï¼å¼å®¹æ²¡æhierarchyInfoçæ°æ®
      const hierarchyInfo = this.getHierarchyInfo(nodeData); //nodeData[this.hierarchyInfoKey];
      if (!hierarchyInfo) {
        return;
      }

      // å¹éèç¹
      const currentLayer = hierarchyInfo['layer'];
      const currentParentElement = hierarchyInfo['parentElement'];
      if ((currentLayer === fLayer + 1) && (currentParentElement === fParentElement || (!currentParentElement && fParentElement === ''))) {
        childNodesData.push(nodeData);
      }
    });
    return childNodesData;
  }
  private getHierarchyInfo(nodeData: any): ParentHierarchyInfo {
    return this.getValue(nodeData, this.hierarchyInfoKey);//nodeData[this.hierarchyInfoKey];
  }
  private getValue(target: any, path: string) {
    if (path.indexOf('/') === -1) {
      return target[path];
    }
    const paths: any = path.split('/').filter(p => p);
    return paths.reduce((result, path) => {
      return result && result[path];
    }, target);
  }
  /**
   * è·ååçº§ä¿¡æ¯ä¸­çå±çº§
   * @param nodeData nodeData
   */
  private getNodeLayer(nodeData: any) {
    const hierarchyInfo = this.getHierarchyInfo(nodeData);
    return hierarchyInfo['layer'];
  }
  /**
   * è·ååçº§ä¿¡æ¯ä¸­çç¶èç¹
   * @param nodeData nodeData
   */
  private getNodeParentElement(nodeData: any) {
    const hierarchyInfo = this.getHierarchyInfo(nodeData);
    return hierarchyInfo['parentElement'];
  }
  /**
   * è·åå±å¼ç¶æ
   */
  private isExpanded(newData: any): boolean {
    const oldTreeNode = this.getOldNode(newData);
    return oldTreeNode ? oldTreeNode.expanded : undefined;
  }

  /**
   * æ¯å¦æ¯å¶å­èç¹
   * @todoï¼åºè¯¥ç¨æ°æ®æ¬èº«çisDetailæ¥ä¿è¯ï¼ä½ç®åä¸åç¡®ï¼å¼ºå¶åç«¯è®¡ç®
   */
  private isLeaf(nodeData: any): boolean {
    const hierarchyInfo = this.getHierarchyInfo(nodeData);//nodeData[this.hierarchyInfoKey];
    const isDetail = hierarchyInfo['isDetail'];
    return isDetail;
  }

  /**
   * å¤æ­èç¹æ¯å¦æ¯æ°å¢
   * @todoï¼ä¸åºè¯¥è¿æ ·å¤æ­ï¼å¾ä¼åã
   * @summary
   * 1ãéç©ºæ ï¼ç©ºæ è§ä¸ºåæ¬¡å è½½æ°æ®ï¼ï¼
   * 2ãæ¾ä¸å°oldNodeã
   */
  private isNewNode(nodeData: any): boolean {
    if (this.allOldNodesMap.size === 0) {
      return false;
    }
    const oldTreeNode = this.getOldNode(nodeData);
    return oldTreeNode ? false : true;
  }

  /**
   * å±å¼ç¶èç¹
   */
  private expandParentNode(nodeData: any): void {
    const parentTreeNode = this.getParentNode(nodeData);
    if (!parentTreeNode) {
      return;
    }
    parentTreeNode.leaf = false;
    parentTreeNode.expanded = true;
  }

  /**
   * æ¥æ¾ç¶èç¹
   */
  private getParentNode(nodeData: any): TreeNode {
    const hierarchyInfo = this.getHierarchyInfo(nodeData);//nodeData[this.hierarchyInfoKey];
    const layer = hierarchyInfo['layer'];
    const parentElement = hierarchyInfo['parentElement'];

    const allNodes = Array.from(this.allNodesMap.values());
    const parentNode = allNodes.find((node: TreeNode) => {
      const currentLayer = this.getValue(node.data, this.hierarchyInfoKey)['layer']; //node.data[this.hierarchyInfoKey]['layer'];
      const currentId = node.data[this.primaryKey];
      return currentId === parentElement && layer === (currentLayer + 1);
    });

    return parentNode;
  }

  /**
   * è·åèçæ èç¹
   */
  private getOldNode(nodeData: any): TreeNode {
    const id = nodeData[this.primaryKey];
    return this.allOldNodesMap.get(id);
  }

  /**
   * æå¹³TreeNodesï¼å¹¶æ¾å¥ä¸ä¸ªMapä¸­
   */
  private buildNodesDataMap(treeNodes: TreeNode[]): void {
    treeNodes.forEach((treeNode: TreeNode) => {
      this.allOldNodesMap.set(treeNode.data[this.primaryKey], treeNode);
      if (treeNode.children) {
        this.buildNodesDataMap(treeNode.children);
      }
    });
  }

  // #endregion
}

export { ParentTreeNodeBuilder };

